import { hasSummaryColumn } from "../monthSummary";
import { AthleteRow } from "./AthleteRow";
import { DashboardTableHeader } from "./DashboardTableHeader";

export function DashboardTable({
  athletes,
  dataKey,
  theme,
  activeMonth,
  metric,
  today,
  isCurrentMonth,
  isPreviousMonth,
  unitSelected,
  activeUser,
  organizationActiveUsers,
  referAsClients,
  showWorkoutsColumn,
  onSortName,
  onSortWorkouts,
  onSortLastLogged,
  onSortSummary,
  t,
}) {
  const showSummary = hasSummaryColumn(metric);
  // Metric views mark each logged day with a small square instead of a tick.
  const isLoggedView =
    !!metric && metric !== "workouts" && metric !== "check-in";

  return (
    // biome-ignore lint/a11y/useValidAriaRole: report-table used for structure
    <table
      role="report-table"
      className={isLoggedView ? "logged-view" : undefined}
    >
      <DashboardTableHeader
        metric={metric}
        dataKey={dataKey}
        athletes={athletes}
        today={today}
        isCurrentMonth={isCurrentMonth}
        onSortName={onSortName}
        onSortWorkouts={onSortWorkouts}
        onSortLastLogged={onSortLastLogged}
        onSortSummary={onSortSummary}
        showWorkoutsColumn={showWorkoutsColumn}
        t={t}
      />
      <tbody>
        {athletes.map((athlete) => (
          <AthleteRow
            key={`athlete-${athlete._id}`}
            athlete={athlete}
            dataKey={dataKey}
            theme={theme}
            activeMonth={activeMonth}
            metric={metric}
            today={today}
            isCurrentMonth={isCurrentMonth}
            isPreviousMonth={isPreviousMonth}
            unitSelected={unitSelected}
            activeUser={activeUser}
            organizationActiveUsers={organizationActiveUsers}
            referAsClients={referAsClients}
            showWorkoutsColumn={showWorkoutsColumn}
            showSummary={showSummary}
            t={t}
          />
        ))}
      </tbody>
    </table>
  );
}
